var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-lg navbar-dark bg-primary"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{name: 'home'}}},[_vm._v("Full Stack Authentication")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }